var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutstandingAssoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 12,
    fill: "#13678A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4718 15.4H28.2013V31.15H12.4718V15.4ZM17.715 20.65V25.9H22.9582V20.65H17.715ZM33.4445 20.65H59.6604V25.9H33.4445V20.65ZM33.4445 41.65H59.6604V46.9H33.4445V41.65ZM17.715 54.775L8.53943 45.5875L12.2359 41.8862L17.715 47.3462L29.7481 35.3237L33.4445 39.025L17.715 54.775Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutstandingAssoc);
export default __webpack_public_path__ + "static/media/outstandingAssoc.ad807822f00afa47c7e30075e8689ad6.svg";
export { ForwardRef as ReactComponent };